module.exports = "<app-modal #popup>\n  <div class=\"app-modal-header\">\n    <h4 class=\"modal-title\">{{'Are you sure?'}}</h4>\n  </div>\n  <div class=\"app-modal-body\">\n    <h4>{{message}}</h4>\n  </div>\n  <div class=\"app-modal-footer\">\n    <div class=\"btn-group-1 text-center\">\n      <button class=\"btn btn-secondary\" (click)=\"cancel()\" [disabled]=\"isSubmitted\">\n        {{'Cancel'}}</button>\n      <button class=\"btn btn-primary\" (click)=\"accept()\" [disabled]=\"isSubmitted\">\n        {{'Yes'}}</button>\n    </div>\n  </div>\n</app-modal>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modal/confirm.popup.html
// module id = 1112
// module chunks = 0 1 2 3 4 5 6 7